// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1lGYh","validationTips":"StatementDescriptor_validationTips__3DZeN"};